import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateFilesAndHistoryQueries } from "@/queries/refetch-files-and-history";

type ImportSchematisationArgs = {
  path: string | "";
  schematisationId: number;
  name: string;
  revisionId: number | undefined;
  projectId: string;
};
export const useImportSchematisation = () => {
  const invalidateFilesAndHistoryQueries = useInvalidateFilesAndHistoryQueries();

  return useMutationWithErrorHandler(
    async ({ path, schematisationId, name, revisionId, projectId }: ImportSchematisationArgs) => {
      const id = path + name;
      const response = await getRanaApiV1().ThreediSchematisationsApi.modelSchematisationsCopy({
        projectId,
        schematisationId,
        path: id,
        revisionId,
      });

      invalidateFilesAndHistoryQueries(projectId, id);

      return response;
    }
  );
};
